import React, { useState, useEffect } from 'react';
import apiObjectTypes from '../../../api/objectTypes';
import MultiSelect from '../../layout/forms/MultiSelect';

const ObjectTypes = ({ selected, setSelected }) => {
    const [objectTypes, setObjectTypes] = useState([]);
    const fetchObjectTypes = async () => {
        const result = await apiObjectTypes.objectTypes.get();
        setObjectTypes(result.map(objectType => ({ label: objectType.type, value: objectType.objectTypeKEY })));
    }
    useEffect(() => {
    fetchObjectTypes();
}, []);
    const setSelectedObjectTypes = (objectTypes) => setSelected({ ...selected, objectTypes });
    return (
        <MultiSelect
            options={objectTypes}
            value={selected.objectTypes}
            onChange={setSelectedObjectTypes}
            labelledBy="ObjectTypes"
            label="Object"
        />
        )
}

export default ObjectTypes